import { UpstreamPullRequestTypeId as UpstreamPullRequestTypeId$1, Pulled as Pulled$1, NoUpstream as NoUpstream$1, isUpstreamPullRequest as isUpstreamPullRequest$1, isPulled as isPulled$1, isNoUpstream as isNoUpstream$1, match as match$1 } from '../../internal/channel/upstreamPullRequest.esm.js';

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const UpstreamPullRequestTypeId = UpstreamPullRequestTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const Pulled = Pulled$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const NoUpstream = NoUpstream$1;

/**
 * Returns `true` if the specified value is an `UpstreamPullRequest`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isUpstreamPullRequest = isUpstreamPullRequest$1;

/**
 * Returns `true` if the specified `UpstreamPullRequest` is a `Pulled`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isPulled = isPulled$1;

/**
 * Returns `true` if the specified `UpstreamPullRequest` is a `NoUpstream`,
 * `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isNoUpstream = isNoUpstream$1;

/**
 * Folds an `UpstreamPullRequest<A>` into a value of type `Z`.
 *
 * @since 2.0.0
 * @category folding
 */
const match = match$1;

export { NoUpstream, Pulled, UpstreamPullRequestTypeId, isNoUpstream, isPulled, isUpstreamPullRequest, match };
